export default [
	{
		path: '/sectors',
		name: 'sectors',
		component: () => import('@/views/Sector/Sectors.vue'),
		meta: { requiresAuth: true, permission: 'view_sectors' }
	},
	{
		path: '/sectors/create',
		name: 'sectors.create',
		component: () => import('@/views/Sector/CreateSector.vue'),
		meta: { requiresAuth: true, permission: 'create_sector' }
	}
]
